import store from 'store';
import { makeRequest } from 'utils/requestLogger';
import config from '../apiConfigs';

export default (payload) => {
  const url = `${config.apiURL}/api${payload.avatar_path}`;
  const p = makeRequest('put', `/api/users/${payload.id}/avatar`, {
    avatar_url: url,
  });

  return p.then((resp) => {
    // dispatch event with the new email
    store.dispatch('changeAvatar', url);
    return resp;
  });
};



// WEBPACK FOOTER //
// ./src/app/services/account/changeAvatar.js